<script>
    import "./modal.css"
    let crossModal = "./images/cross.svg"
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    const modalAction = () => {
        dispatch("modalAction")
    }
    export let modalStatus;
</script>
{#if modalStatus}
<div class="pl-modal pl-preview-modal-wrapper">
    <div class="pl-modal-dialog flex items-center">
        <div class="pl-modal-content flex column-direction">
            <div class="container">
                <div class="back-project back-project-modal flex items-center">
                    <a href="javascript:void(0)" id="back-creation-from" on:click={modalAction} class="flex items-center">
                        <img src="./images/back-arrow.svg" alt="backButton"> Back To Creation Form
                    </a><span>|</span>Project Preview
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</div>
    {/if}